// src/theme/AppThemeProvider.jsx
import React, { createContext, useState, useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { getDesignTokens } from '@theme/getDesignTokens.js';
import { buildCustomizations } from '@theme/Customizations';
import { ColorModeContext } from '@theme/themePrimitives.js';


export default function AppThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem('mode') || 'light');

  const toggleColorMode = useMemo(() => {
    return () => {
      setMode((prev) => {
        const next = prev === 'light' ? 'dark' : 'light';
        localStorage.setItem('mode', next);
        return next;
      });
    };
  }, []);

  const theme = useMemo(() => {
    const base = createTheme(getDesignTokens(mode));
    base.components = {
      ...base.components,
      ...buildCustomizations(base),
    };
    return base;
  }, [mode]);

  const colorModeValue = useMemo(
    () => ({ mode, toggleColorMode }),
    [mode, toggleColorMode]
  );

  return (
    <ColorModeContext.Provider value={colorModeValue}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles
          styles={(muiTheme) => ({
            body: {
              backgroundImage:
                'radial-gradient(ellipse at 70% 51%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
              backgroundSize: 'cover',
              ...muiTheme.applyStyles('dark', {
                backgroundImage:
                  'radial-gradient(at 70% 51%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
              }),
            },
          })}
        />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
